<div class="animated fadeInRight">
  <!-- Tarjeta Principal con la Grilla -->
  <app-lfsa-card-v2
    [titulo]="'Mantenimiento de Registros - Matriz QM'"
    [modulo]="'PLM Calidad'"
    [tituloCard]="'Listado Matriz QM'"
    [innTemplate]="enviarTemplateEdit"
    [innTemplateButton]="innTemplateButton">
  </app-lfsa-card-v2>

  <!-- Botón para abrir el modal -->
  <ng-template #innTemplateButton>
    <div class="col-md-6 mb-2">
      <div class="pagetitle">
        <div class="btn-group-justified btn-group" style="float: right;">
          <button (click)="openNew()" class="btn btn-primary">
            <i aria-hidden="true" class="fa fa-plus"></i> Agregar
          </button>
        </div>
      </div>
    </div>
  </ng-template>

  <!-- Contenido de la tarjeta: Filtro y Grilla -->
  <ng-template #enviarTemplateEdit>
    <div class="form-group col-md-12 mb-2">
      <input class="form-control" placeholder="Buscar..." [(ngModel)]="textoBuscar" (keyup)="onQuickFilterChanged()" />
    </div>
    <br>
    <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
    <ag-grid-angular
      #agGrid
      class="ag-theme-alpine"
      style="width: 100%; height: 450px;"
      [rowData]="data"
      [columnDefs]="columnDefs"
      [pagination]="true"
      [paginationPageSize]="10"
      [frameworkComponents]="frameworkComponents"
      (gridReady)="onGridReady($event)">
    </ag-grid-angular>
  </ng-template>
</div>

  <!-- MODAL para Crear/Editar -->
  <app-lfsa-modal [innTemplate]="abrirModal" [classModal]="'modal-dialog modal-xl'" [idButton]="'abrirModal'"
                  [idOpen]="'Modal'" [idClose]="'cerrarModal'" [titulo]="titleModal">
  </app-lfsa-modal>

  <ng-template #abrirModal>
    <div class="container-fluid">
      <form [formGroup]="form" novalidate class="form-group">
        <h6 class="mt-2 text-primary">IDENTIFICACION</h6><hr>
        <div class="row mb-3">
          <div class="col">
              <label for="usuario">Tipo</label>
              <ng-select [items]="listTipoMaterial"
                          formControlName="tipo"
                          placeholder="Seleccione tipo"
                          [clearable]="false"
                          bindLabel="idTipoMaterial"
                          bindValue="idTipoMaterial"
                          (change)="OnChangeTipo($event);">
              </ng-select>
          </div>

          <div class="col">
              <label for="usuario">Grupo</label>
              <ng-select [items]="listGrupoMaterial"
                          formControlName="grupo"
                          placeholder="Seleccione grupo"
                          [clearable]="false"
                          bindLabel="dscaGrupoArticulo"
                          bindValue="idGrupoArticulo"
                          (change)="OnChangeGrupo($event);">
              </ng-select>
          </div>
          
          <div class="col">
            <app-lfsa-combo-box [label]="'Clase de Inspección'" 
              formControlName="claseInspeccion" 
              [control]="form.get('claseInspeccion')" 
              [comboBox]="catalogoClaseInspeccion" 
              [opcion]="'valor'" 
              [idOpcion]="'clave'" 
              class="form-control-sm"
              [habilitar]="!isNew"
              [isReadOnly]="true">
            </app-lfsa-combo-box></div>
        </div>

        <div class="row">
          <div class="col"><app-lfsa-input formControlName="descripcionTipoMaterial" [label]="'Desc. Tipo Material'" [id]="'descripcionTipoMaterial'" [control]="form.get('descripcionTipoMaterial')" [type]="'text'" class="form-control-sm" [isReadOnly]="true"></app-lfsa-input></div>
          <div class="col"><app-lfsa-input formControlName="descripcionGrupo" [label]="'Desc. Grupo'" [id]="'descripcionGrupo'" [control]="form.get('descripcionGrupo')" [type]="'text'" class="form-control-sm" [isReadOnly]="true"></app-lfsa-input></div>
          <div class="col"><app-lfsa-input formControlName="descripcionMacrocategoria" [label]="'Desc. Macrocategoría'" [id]="'descripcionMacrocategoria'" [control]="form.get('descripcionMacrocategoria')" [type]="'text'" class="form-control-sm" [isReadOnly]="true"></app-lfsa-input></div>
        </div>

        <!-- GESTIÓN QM -->
        <h6 class="mt-4 text-primary">GESTIÓN QM</h6><hr>
        <div class="row mb-3">
          <div class="col"><app-lfsa-combo-box [label]="'Gestión QM'" formControlName="gestionQm" [control]="form.get('gestionQm')" [comboBox]="siNoVacioOptions" [opcion]="'label'" [idOpcion]="'value'" class="form-control-sm"></app-lfsa-combo-box></div>
          <div class="col"><app-lfsa-combo-box [label]="'Especificación RDL'" formControlName="especificacionRdl" [control]="form.get('especificacionRdl')" [comboBox]="siNoVacioOptions" [opcion]="'label'" [idOpcion]="'value'" class="form-control-sm"></app-lfsa-combo-box></div>
          <div class="col"><app-lfsa-combo-box [label]="'Inst. Proceso Insp. 03'" formControlName="instruccionProcesoClaseInsp03" [control]="form.get('instruccionProcesoClaseInsp03')" [comboBox]="siNoVacioOptions" [opcion]="'label'" [idOpcion]="'value'" class="form-control-sm"></app-lfsa-combo-box></div>
          <div class="col"><app-lfsa-combo-box [label]="'Op. QM Insp. 03'" formControlName="operacionesQmClaseInsp03" [control]="form.get('operacionesQmClaseInsp03')" [comboBox]="siNoVacioOptions" [opcion]="'label'" [idOpcion]="'value'" class="form-control-sm"></app-lfsa-combo-box></div>
          <div class="col"><app-lfsa-combo-box [label]="'Aprov. Activo'" formControlName="aprovActivo" [control]="form.get('aprovActivo')" [comboBox]="siNoVacioOptions" [opcion]="'label'" [idOpcion]="'value'" class="form-control-sm"></app-lfsa-combo-box></div>
        </div>
        
        <!-- DATOS TÉCNICOS -->
        <h6 class="mt-4 text-primary">DATOS TÉCNICOS</h6><hr>
        <div class="row">
          <div class="col">
            <app-lfsa-combo-box [label]="'Clave QM'" [mostrarImg]="false" formControlName="claveQm" [control]="form.get('claveQm')" [comboBox]="claveQmOptions"
                                [opcion]="'label'" [idOpcion]="'value'" class="form-control-sm" [id]="'claveQm'">
            </app-lfsa-combo-box>
          </div>
          <div class="col">
            <app-lfsa-combo-box [label]="'Tipo COA'" [mostrarImg]="false" formControlName="tipoCoa" [control]="form.get('tipoCoa')" [comboBox]="tipoCoaOptions"
                                [opcion]="'label'" [idOpcion]="'value'" class="form-control-sm" [id]="'tipoCoa'">
            </app-lfsa-combo-box>
          </div>
          <div class="col">
            <app-lfsa-combo-box [label]="'Punto Inspección'" [mostrarImg]="false" formControlName="puntoInspeccion" [control]="form.get('puntoInspeccion')" [comboBox]="siNoVacioOptions"
                                [opcion]="'label'" [idOpcion]="'value'" class="form-control-sm" [id]="'puntoInspeccion'">
            </app-lfsa-combo-box>
          </div>
          <div class="col">
            <app-lfsa-input formControlName="tipoPuntoInspeccion" [label]="'Tipo Punto Inspección'" [id]="'tipoPuntoInspeccion'"
                            [control]="form.get('tipoPuntoInspeccion')" [type]="'text'" class="form-control-sm">
            </app-lfsa-input>
          </div>
          <div class="col">
            <app-lfsa-combo-box [label]="'Clase Utilización'" [mostrarImg]="false" formControlName="claseUtilizacion" [control]="form.get('claseUtilizacion')" [comboBox]="catalogoClaseUtilizacion"
                                [opcion]="'valor'" [idOpcion]="'clave'" class="form-control-sm" [id]="'claseUtilizacion'">
            </app-lfsa-combo-box>
          </div>
        </div>
        <div class="row">
          <div class="col"><app-lfsa-combo-box [label]="'PM0001 Cuantitativa'" formControlName="pm0001Cuantitativa" [control]="form.get('pm0001Cuantitativa')" [comboBox]="pmCuantitativaOptions('PM0001')" [opcion]="'label'" [idOpcion]="'value'" class="form-control-sm"></app-lfsa-combo-box></div>
          <div class="col"><app-lfsa-combo-box [label]="'PM0002 Cualitativa'" formControlName="pm0002Cualitativa" [control]="form.get('pm0002Cualitativa')" [comboBox]="pmCualitativaOptions('PM0002')" [opcion]="'label'" [idOpcion]="'value'" class="form-control-sm"></app-lfsa-combo-box></div>
          <div class="col"><app-lfsa-combo-box [label]="'PM0003 Cuantitativa'" formControlName="pm0003Cuantitativa" [control]="form.get('pm0003Cuantitativa')" [comboBox]="pmCuantitativaOptions('PM0003')" [opcion]="'label'" [idOpcion]="'value'" class="form-control-sm"></app-lfsa-combo-box></div>
        </div>
        <div class="row">
          <div class="col"><app-lfsa-combo-box [label]="'PM0004 Cualitativa'" formControlName="pm0004Cualitativa" [control]="form.get('pm0004Cualitativa')" [comboBox]="pmCualitativaOptions('PM0004')" [opcion]="'label'" [idOpcion]="'value'" class="form-control-sm"></app-lfsa-combo-box></div>
          <div class="col"><app-lfsa-combo-box [label]="'PM0005 Cuantitativa'" formControlName="pm0005Cuantitativa" [control]="form.get('pm0005Cuantitativa')" [comboBox]="pmCuantitativaOptions('PM0005')" [opcion]="'label'" [idOpcion]="'value'" class="form-control-sm"></app-lfsa-combo-box></div>
          <div class="col"><app-lfsa-combo-box [label]="'PM0006 Cualitativa'" formControlName="pm0006Cualitativa" [control]="form.get('pm0006Cualitativa')" [comboBox]="pmCualitativaOptions('PM0006')" [opcion]="'label'" [idOpcion]="'value'" class="form-control-sm"></app-lfsa-combo-box></div>
        </div>

        <!-- CARACTERISTICAS-->
        <h6 class="mt-4 text-primary">MATRIZ DE CARACTERISTICAS</h6><hr>
        <div class="row mb-3">
          <div class="col"><app-lfsa-combo-box [label]="'C1001-A001'" formControlName="c1001A001" [control]="form.get('c1001A001')" [comboBox]="c1001Options('A001')" [opcion]="'label'" [idOpcion]="'value'" class="form-control-sm"></app-lfsa-combo-box></div>
          <div class="col"><app-lfsa-combo-box [label]="'C1001-A002'" formControlName="c1001A002" [control]="form.get('c1001A002')" [comboBox]="c1001Options('A002')" [opcion]="'label'" [idOpcion]="'value'" class="form-control-sm"></app-lfsa-combo-box></div>
          <div class="col"><app-lfsa-combo-box [label]="'C1001-A003'" formControlName="c1001A003" [control]="form.get('c1001A003')" [comboBox]="c1001Options('A003')" [opcion]="'label'" [idOpcion]="'value'" class="form-control-sm"></app-lfsa-combo-box></div>
          <div class="col"><app-lfsa-combo-box [label]="'C1001-A004'" formControlName="c1001A004" [control]="form.get('c1001A004')" [comboBox]="c1001Options('A004')" [opcion]="'label'" [idOpcion]="'value'" class="form-control-sm"></app-lfsa-combo-box></div>
        </div>
        <div class="row mb-3">
          <div class="col"><app-lfsa-combo-box [label]="'C1001-A005'" formControlName="c1001A005" [control]="form.get('c1001A005')" [comboBox]="c1001Options('A005')" [opcion]="'label'" [idOpcion]="'value'" class="form-control-sm"></app-lfsa-combo-box></div>
          <div class="col"><app-lfsa-combo-box [label]="'C1001-A006'" formControlName="c1001A006" [control]="form.get('c1001A006')" [comboBox]="c1001Options('A006')" [opcion]="'label'" [idOpcion]="'value'" class="form-control-sm"></app-lfsa-combo-box></div>
          <div class="col"><app-lfsa-combo-box [label]="'C1001-A009'" formControlName="c1001A009" [control]="form.get('c1001A009')" [comboBox]="c1001Options('A009')" [opcion]="'label'" [idOpcion]="'value'" class="form-control-sm"></app-lfsa-combo-box></div>
          <div class="col"><app-lfsa-combo-box [label]="'C1002-A001'" formControlName="c1002A001" [control]="form.get('c1002A001')" [comboBox]="c1002Options('A001')" [opcion]="'label'" [idOpcion]="'value'" class="form-control-sm"></app-lfsa-combo-box></div>
        </div>
        <div class="row mb-3">
          <div class="col"><app-lfsa-combo-box [label]="'C1002-A006'" formControlName="c1002A006" [control]="form.get('c1002A006')" [comboBox]="c1002Options('A006')" [opcion]="'label'" [idOpcion]="'value'" class="form-control-sm"></app-lfsa-combo-box></div>
          <div class="col"><app-lfsa-combo-box [label]="'C1002-A007'" formControlName="c1002A007" [control]="form.get('c1002A007')" [comboBox]="c1002Options('A007')" [opcion]="'label'" [idOpcion]="'value'" class="form-control-sm"></app-lfsa-combo-box></div>
          <div class="col"><app-lfsa-combo-box [label]="'C1002-A008'" formControlName="c1002A008" [control]="form.get('c1002A008')" [comboBox]="c1002Options('A008')" [opcion]="'label'" [idOpcion]="'value'" class="form-control-sm"></app-lfsa-combo-box></div>
          <div class="col"><app-lfsa-combo-box [label]="'C1002-A009'" formControlName="c1002A009" [control]="form.get('c1002A009')" [comboBox]="c1002Options('A009')" [opcion]="'label'" [idOpcion]="'value'" class="form-control-sm"></app-lfsa-combo-box></div>
        </div>
        <div class="row mb-3">
          <div class="col"><app-lfsa-combo-box [label]="'C2001-A001'" formControlName="c2001A001" [control]="form.get('c2001A001')" [comboBox]="c2001Options('A001')" [opcion]="'label'" [idOpcion]="'value'" class="form-control-sm"></app-lfsa-combo-box></div>
          <div class="col"><app-lfsa-combo-box [label]="'C2001-A010'" formControlName="c2001A010" [control]="form.get('c2001A010')" [comboBox]="c2001Options('A010')" [opcion]="'label'" [idOpcion]="'value'" class="form-control-sm"></app-lfsa-combo-box></div>
          <div class="col"><app-lfsa-combo-box [label]="'C3001-A001'" formControlName="c3001A001" [control]="form.get('c3001A001')" [comboBox]="c3001Options('A001')" [opcion]="'label'" [idOpcion]="'value'" class="form-control-sm"></app-lfsa-combo-box></div>
          <div class="col"><app-lfsa-combo-box [label]="'C3001-A012'" formControlName="c3001A012" [control]="form.get('c3001A012')" [comboBox]="c3001Options('A012')" [opcion]="'label'" [idOpcion]="'value'" class="form-control-sm"></app-lfsa-combo-box></div>
        </div>

        <!-- CHECKBOXES -->
        <h6 class="mt-4 text-primary">QMs</h6><hr>
        <div class="row mb-3">
          <div class="col-3"><div class="form-check"><input class="form-check-input" formControlName="qm1001" id="qm1001" type="checkbox"><label class="form-check-label" for="qm1001">QM1001</label></div></div>
          <div class="col-3"><div class="form-check"><input class="form-check-input" formControlName="qm1002" id="qm1002" type="checkbox"><label class="form-check-label" for="qm1002">QM1002</label></div></div>
          <div class="col-3"><div class="form-check"><input class="form-check-input" formControlName="qm2001" id="qm2001" type="checkbox"><label class="form-check-label" for="qm2001">QM2001</label></div></div>
          <div class="col-3"><div class="form-check"><input class="form-check-input" formControlName="qm3001" id="qm3001" type="checkbox"><label class="form-check-label" for="qm3001">QM3001</label></div></div>
        </div>

        <h6 class="mt-4">REGISTRO SUJETO A AUDITORIA</h6><hr>

        <!-- Botones del Formulario -->
        <app-lfsa-botones-formulario
          (devolverAccion)="acciones($event)"
          [formularioValido]="form.invalid"
          [loading]="loading" [textBoton]="'Guardar'" class="row p-3">
        </app-lfsa-botones-formulario>
      </form>
    </div>
  </ng-template>

